import React from 'react';
import { useIntl } from 'react-intl';
import { Tooltip, Typography } from '@mui/material';

import { Icon, useSettings, Utils } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';

export function LineTotalCell({ price, isGift }: { price?: number; isGift?: boolean }) {
	const { t } = useSettings();

	if (!!price && isGift)
		return (
			<Tooltip title={ViewTableUtils.renderCurrency({ value: price })} arrow>
				<div>
					{ViewTableUtils.renderSquareChip({
						value: t('LINES_ISGIFT'),
						icon: <Icon icon="gift" size={16} />
					})}
				</div>
			</Tooltip>
		);

	if (price || price === 0) {
		return ViewTableUtils.renderCurrency({ value: price });
	}

	return '-';
}

export function LinesTableFooterInfo({ totTaxExcl, totTaxIncl }: { totTaxExcl?: number; totTaxIncl?: number }) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<div className="h-full p-6">
			{(totTaxExcl || totTaxExcl === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{ id: 'linesTable.totalTaxExcluded', defaultMessage: t('TOT_VALUE_TAX_EXCLUDED') },
						{ value: Utils.formatCurrency(totTaxExcl) }
					)}
				</Typography>
			)}
			{(totTaxIncl || totTaxIncl === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{ id: 'linesTable.totalTaxIncluded', defaultMessage: t('TOT_VALUE_TAX_INCLUDED') },
						{ value: Utils.formatCurrency(totTaxIncl) }
					)}
				</Typography>
			)}
		</div>
	);
}

export default {
	LineTotalCell,
	LinesTableFooterInfo
};
